import { pascalCaseToCamelCaseReviver } from "./PascalCaseToCamelCaseReviver.function";
import { PascalToCamel } from "./types/PascalToCamel";

export function camelCaseModifier<T = any>(data: string): PascalToCamel<T> {
    return JSON.parse(data, pascalCaseToCamelCaseReviver);
}
